import { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { isValidArray, normalizePath } from "../../Layout/Common/common";
import { QuerySuggestionSkeleton } from "../../Skeleton/autoSuggestPopup/querySuggestionSkeleton";
import { CategoryLink } from "./categoryLink";
import { GlobalContext } from "../../Context/GlobalContext";

export const CategorySuggestion = ({ suggestions, isOpen }) => {
  const [categoryList, setCategoryList] = useState(null);
  const { categoryDataAll } = useContext(GlobalContext);
  const categoriesLoaded = Boolean(categoryDataAll);
  useEffect(() => {
    if (isValidArray(suggestions) && categoriesLoaded) {
      setCategoryList(suggestions[0].categories);
    }
  }, [suggestions, categoriesLoaded]);

  return (
    <Fragment>
      <div className="search-tags-title ">
        <h5>Category</h5>
      </div>
      <div className="search-tags-details">
        {isOpen ? (
          <ul style={{ height: "auto" }}>
            {isValidArray(categoryList) &&
              categoryList.map((item, index) => (
                <li key={index}>
                  <CategoryLinkTag item={item} />
                </li>
              ))}
          </ul>
        ) : (
          <QuerySuggestionSkeleton />
        )}
      </div>
    </Fragment>
  );
};

const CategoryLinkTag = ({ item }) => {
  const [url, setUrl] = useState();
  const { categoryDataAll } = useContext(GlobalContext);
  useEffect(() => {
    if (categoryDataAll && item) {
      const filtered = categoryDataAll.find((cat) => normalizePath(item) == normalizePath(cat.categoryName));
      if (filtered && filtered.url) setUrl(filtered.url);
      else setUrl("/search?q=" + encodeURI(normalizePath(item)));
    }
  }, [item, categoryDataAll]);
  return (
    <Link to={url}>
      <span className="wes-search" />
      {item}
    </Link>
  );
};
